module.exports = __webpack_public_path__ + "media/img/ms-icon-150x150-52613e861ddf31ad69e756fc8998a693.png";